<form
  name="form"
  fxLayout="column"
  autocomplete="off"
  class="field-dialog__content__scroll tab-users p-24"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  fusePerfectScrollbar
>
  <div class="field-outline-form">
    <div class="tab-users__search-bar" fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="12px">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>
          {{ 'GROUPS.DIALOG.TABS.USERS.LINKED.SEARCH' | translate }}
        </mat-label>

        <mat-icon matPrefix color="primary">search</mat-icon>

        <input matInput [formControl]="searchInputValue" (keydown)="$event.stopImmediatePropagation()" />

        <mat-hint>
          {{ 'GROUPS.DIALOG.TABS.USERS.SEARCH_SUGGESTION' | translate }}
        </mat-hint>
      </mat-form-field>

      <button
        *ngIf="!isViewMode"
        (click)="linkUsers()"
        class="tab-users__search-bar__button"
        mat-raised-button
        color="primary"
        fxFlex="25"
      >
        {{ 'GROUPS.DIALOG.TABS.USERS.LINKED.ADD' | translate }}
      </button>
    </div>
  </div>

  <linked-users
    [linkedUsers]="linkedUsers"
    [searchInputValue]="searchInputValue"
    [isViewMode]="isViewMode"
    [groupId]="groupId"
    [reload]="reload"
  >
  </linked-users>
</form>
